import React from 'react';
import getChildren, { flattenChildren } from '../../utils/children';
import NavItemProps from './props';

const NavItemContainer = ({ classes, content }: NavItemProps) => <>
	{
		getChildren(
			flattenChildren(content).map(node => ({ ...node, classes }))
		)
	}
</>;

export default NavItemContainer;
